
// Only Latin letters (including accents) for analysis
const LETTERS_REGEX = /[A-Za-zÀ-ÖØ-öø-ÿ]/g;
const VOWELS_REGEX = /[AEIOUYĄĘÓaeiouyąęóÀ-ÖØ-öø-ÿ]/g;
const UPPER_REGEX = /[A-ZÀ-ÖØ-Þ]/g;
const CONSONANT_RUN_REGEX = /[BCDFGHJKLMNPQRSTVWXYZbcdfghjklmnpqrstvwxyz]{6,}/;

/**
 * Returns a score between 0 and 1 for 'this looks random.'
 * 0 = nothing unusual, 1 = most likely garbage.
 */
export function scoreWeirdName(raw: string): number {
    const s = (raw || '').trim();

    if (!s) return 0;

    const letters = (s.match(LETTERS_REGEX) || []).join('');
    const len = letters.length;
    if (len === 0) return 0;

    let score = 0;

    // 1) Length
    if (len > 24) score += 0.5;
    else if (len > 18) score += 0.3;
    else if (len > 14) score += 0.1;

    // 2) Vowel ratio (very few vowels = suspicious)
    const vowelsCount = (letters.match(VOWELS_REGEX) || []).length;
    const vowelRatio = vowelsCount / len;

    if (vowelRatio < 0.20) score += 0.4;
    else if (vowelRatio < 0.27) score += 0.25;

    // 3) Capitalization pattern
    const upperCount = (letters.match(UPPER_REGEX) || []).length;
    const isTitleCase = /^[A-ZÀ-ÖØ-Þ][a-zà-öø-ÿ'-]*$/.test(s);

    if (!isTitleCase && upperCount >= 3) score += 0.4;
    else if (!isTitleCase && upperCount >= 2) score += 0.25;

    // 4) Long consonant runs
    if (CONSONANT_RUN_REGEX.test(letters)) score += 0.35;

    // 5) Unusual characters/symbols in a 'name'
    if (/[^A-Za-zÀ-ÖØ-öø-ÿ' -]/.test(s)) score += 0.3;

    return Math.min(1, score);
}

export function isVerySuspiciousName(name: string): boolean {
    return scoreWeirdName(name) >= 0.8;
}

export const normalizeEmail = (email: string): string => email.trim().toLowerCase();
